import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

const Image = styled.img`
  max-width: 100%;
  grid-area: logo;
  align-self: center;
  justify-self: center;
`;

const IconLogo = styled(Icon)`
  font-size: 0.8rem;
  grid-area: logo;
  align-self: center;
  justify-self: center;
`;

export default ({ logo_type, logo }) =>
  logo_type === 'bank_institution' ? (
    <Image src={logo} />
  ) : logo_type === 'bank_default' ? (
    <IconLogo name="university" />
  ) : null;
